import  * as React from 'react'
import {ICreateGifModalProps} from "./ICreateGifModalProps";
import {ICreateGifModalState} from "./ICreateGifModalState";
import Popup from "reactjs-popup";
import {Link , withRouter} from 'react-router-dom'
import Hidden from '@material-ui/core/Hidden';
import 'src/assets/css/dropZone.css'
import 'src/assets/css/main.css'
import 'src/assets/css/modalCreate.css'
import icon1 from 'src/assets/images/icon.svg'
import pen  from 'src/assets/images/pen.png'

import icon2 from 'src/assets/images/ion2.svg'

class CreateGifModalComponent extends React.Component<ICreateGifModalProps , ICreateGifModalState>{


    constructor(props:ICreateGifModalProps){
        super(props)

        this.state = {
            value: "image/jpeg, image/png, .jpg, .jpeg, .png , .mp4 ",
            previews: [],
            accepted: [],
            open : false
        }
    }

    openModal = () => {
        this.setState({
            open: true
        })
    }

    closeModal = () => {
        this.setState({ open: false })
    }


    handleChange = (close) => {

        let link: any;

        (() => {
            link = document.querySelector("#link");
        })();

        console.log(link , 'llllllllll')
        if (link && link.value  ){
        this.props.history.push({
            pathname: '/creategifYoutube',
            search: '',
            state: { link: link.value }
        })
            close

        }


    }
    onDrop = (accepted, rejected, links) => {

        accepted = accepted.map(v => v);
        var newAccepted = [...this.state.accepted, ...accepted, ...links];
        this.setState({
            accepted: newAccepted
        });

    };




    public render() {

        return (

            <Popup trigger={
                <>
                    <a onClick= {this.openModal} className='create _btn _web_btn' style={{cursor:'pointer'}} ><span>CRÉER</span></a>
                    <div onClick= {this.openModal} className="_mob_btn" data-href="link">
                            <div className="_img">
                                <img src={pen} style={{maxWidth: "40px"}} alt="icone footer menu"/>
                            </div>
                            <span>Créer</span>
                    </div>
                </>
            } position="right center"
                   modal
                   open={this.state.open}
                   onClose={this.closeModal}
            >{close =>
                <div className="modalContainer">
                    <div className="titre">CRÉER</div>
                    <div className="description"> Créez votre collection GIF à partager sur Facebook, Twitter,<br />
                     Instagram, SMS, e-mail et partout ailleurs.</div>
                    <div className="btnContainer">


                        <div className="btn"  onClick={()=> {this.props.history.push('/creategifPhotos') ;this.setState({
                            open: false
                        })}}>
                            <div className="btnIcon"><img src={icon1}/></div>
                            <div className="btninsideContainer">
                                <div className="firstTitle" onClick={close} >CRÉER UN GIF À PARTIR D'IMAGES</div>
                         {/*       <div className="secondTitle">Upload PICTURES from your device</div>
*/}
                            </div>
                        </div>

                        <div className="btn" onClick={()=> { this.props.history.push('/creategifVideo') ; close}}>
                            <div className="btnIcon"><img src={icon2}/></div>
                            <div className="btninsideContainer">
                                <div className="firstTitle" onClick={close}>CRÉER UN GIF DE VIDÉO</div>

                            </div>
                        </div>
                    </div>

                      <div className=" ui input  " style={{
                          display : 'flex',
                          flexDirection : 'column',
                          alignItems: 'center',
                          marginLeft: '8%' , width:'84%' , marginTop : '15px'}} >
                        <input type="text" placeholder="COPIER ET COLLER UN LIEN DE YOUTUBE" id="link" onChange={()=>{this.handleChange(close) } } className="inputUrl"/>

                          <button className={'btn'} style={{
                              marginTop : '2%'
                          }} onClick={()=>{this.handleChange(close) } }> Créer </button>
                    </div>
                </div>}
            </Popup>

        );
    }



}
export default (withRouter(CreateGifModalComponent))





// WEBPACK FOOTER //
// ./src/components/createGifModalComponent/CreateGifModalComponent.tsx